module.exports = __webpack_public_path__ + "a045c9a1e883d22bf0e02702305981cd.svg";